module.exports = __webpack_public_path__ + "img/aboutus1.751d7ba3.png";